module.exports = __webpack_public_path__ + "static/img/banner.5f8dd82.png";


//////////////////
// WEBPACK FOOTER
// ./static/subscribe/banner.png
// module id = U2SK
// module chunks = 1